let Fsc = {
  initSertificateSlider: function(slider){
    slider.slick({
      adaptiveHeight: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      speed: 600,
      infinite: true,
      prevArrow : '<div class="slick-prev"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
      nextArrow : '<div class="slick-next"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
}

$(document).ready(function ($) {

  let sliderSertificateFsc = $('[data-fsc-sertificate-slider]');

  if(sliderSertificateFsc.length){
    Fsc.initSertificateSlider(sliderSertificateFsc);
  }
    
});



// WEBPACK FOOTER //
// ./components/fsc.js